export default __webpack_public_path__ + "static/bio2-a064ccb0f19e8aeecf2d348eb408fdfd.jpg";